import { DTOButtonComponent, DTOComponent } from "vue-app/api/dto";

export function fixComponents(components: DTOComponent[]): DTOComponent[] {
  const buttonsIndex = components.findIndex((c) => c.type === "BUTTONS");
  if (buttonsIndex !== -1) {
    for (
      let buttonIndex = 0;
      buttonIndex < (components[buttonsIndex] as DTOButtonComponent).buttons.length;
      buttonIndex++
    ) {
      if ((components[buttonsIndex] as DTOButtonComponent).buttons[buttonIndex].type === "URL") {
        (components[buttonsIndex] as DTOButtonComponent).buttons[buttonIndex].example =
          "https://api.edrone.me/whatsapp-link?hash=";
      }
    }
  }
  return components;
}
